<div class="table">

    <!-- Header row -->
    <div class="header row">
        <!-- General info -->
        <header-cell class="cell code" [column]="_columns['calculation']['code']"></header-cell>
        <header-cell class="cell description" [column]="_columns['calculation']['description']"></header-cell>
        <header-cell class="cell quantity" [column]="_columns['calculation']['quantity']"></header-cell>
        <header-cell class="cell unit" [column]="_columns['calculation']['unit']"></header-cell>

        <!-- Hours -->
        <header-cell class="cell hour-norm" [column]="_columns['calculation']['hour-norm']"></header-cell>
        <header-cell class="cell hour-net" [column]="_columns['calculation']['hour-net']"></header-cell>
        <header-cell class="cell wage-net" [column]="_columns['calculation']['wage-net']"></header-cell>
        <header-cell class="cell hour-percent" [column]="_columns['calculation']['hour-percent']"></header-cell>
        <header-cell class="cell hour-gross" [column]="_columns['calculation']['hour-gross']"></header-cell>

        <!-- Materials -->
        <header-cell class="cell material-norm" [column]="_columns['calculation']['material-norm']"></header-cell>
        <header-cell class="cell material-net" [column]="_columns['calculation']['material-net']"></header-cell>
        <header-cell class="cell material-percent" [column]="_columns['calculation']['material-percent']"></header-cell>
        <header-cell class="cell material-gross" [column]="_columns['calculation']['material-gross']"></header-cell>

        <!-- Equipment -->
        <header-cell class="cell equipment-norm" [column]="_columns['calculation']['equipment-norm']"></header-cell>
        <header-cell class="cell equipment-net" [column]="_columns['calculation']['equipment-net']"></header-cell>
        <header-cell class="cell equipment-percent"
            [column]="_columns['calculation']['equipment-percent']"></header-cell>
        <header-cell class="cell equipment-gross" [column]="_columns['calculation']['equipment-gross']"></header-cell>

        <!-- Subcontracting -->
        <header-cell class="cell subcontracting-norm"
            [column]="_columns['calculation']['subcontracting-norm']"></header-cell>
        <header-cell class="cell subcontracting-net"
            [column]="_columns['calculation']['subcontracting-net']"></header-cell>
        <header-cell class="cell subcontracting-percent"
            [column]="_columns['calculation']['subcontracting-percent']"></header-cell>
        <header-cell class="cell subcontracting-gross"
            [column]="_columns['calculation']['subcontracting-gross']"></header-cell>

        <!-- Totals -->
        <header-cell class="cell norm total" [column]="_columns['calculation']['total-norm']"></header-cell>
        <header-cell class="cell net total" [column]="_columns['calculation']['total-net']"></header-cell>
        <header-cell class="cell gross total" [column]="_columns['calculation']['total-gross']"></header-cell>
    </div>

    <!-- NEW RENDERING STRATEGY -->
    <div class="virtual-scroll-main">
        <div #virtualScrollContainer class="virtual-scroll-container">
            <!-- Locked overlay -->
            <div *ngIf="_isLocked" class="overlay" (wheel)="_handlePassOnScroll($event)"></div>

            <div class="virtual-scroll-content">

                <!-- ORIGINAL TEMPLATE FOR PAGED LINE TABLE -->
                <div #tableBody class="body" [style.top.px]="scrollOffset | async">
                    <!-- Selection highlight -->
                    <div class="selection-highlight" *ngIf="_selectionCurrentHighlight"
                        [style.top.px]="_selectionCurrentHighlight.top"
                        [style.left.px]="_selectionCurrentHighlight.left"
                        [style.width.px]="_selectionCurrentHighlight.width"
                        [style.height.px]="_selectionCurrentHighlight.height">
                    </div>

                    <ng-container *ngIf="_selectionOriginHighlight">
                        <div class="selection-highlight origin" [style.top.px]="_selectionOriginHighlight.top"
                            [style.left.px]="_selectionOriginHighlight.left"
                            [style.width.px]="_selectionOriginHighlight.width"
                            [style.height.px]="_selectionOriginHighlight.height"></div>

                        <div class="selection-highlight global" [style.top.px]="_selectionHighlight.top"
                            [style.left.px]="_selectionHighlight.left" [style.width.px]="_selectionHighlight.width"
                            [style.height.px]="_selectionHighlight.height"></div>
                    </ng-container>

                    <!-- Table body contents -->
                    <div [style.margin-top.px]="_topMargin"></div>

                    <ng-container *ngFor="let row of (displayVisibleLines$ | async)">

                        <ng-container [ngSwitch]="row.type">

                            <!-- The row is a category -->
                            <category-row *ngSwitchCase="'category'" [category]="row" [columns]="_columns['category']"
                                [index]="row.index"></category-row>

                            <!-- The row is a sub category -->
                            <sub-category-row *ngSwitchCase="'subcategory'" [subcategory]="row"
                                [columns]="_columns['subcategory']" [index]="row.index"></sub-category-row>

                            <sub-category-total-row *ngSwitchCase="'subtotal'" class="sub-cat-total"
                                [class.final-row]="row.last" [subcategory]="row"
                                [columns]="_columns['subtotal']"></sub-category-total-row>

                            <!-- The row is a line -->
                            <line-row *ngSwitchCase="'calculation'" [lineValue]="row"
                                [columns]="_columns['calculation']" [selection]="_selection$ | async"
                                [index]="row.index" [allowedUnits]="allowedUnits"
                                (selectionChange)="updateSelectionRects()" (change)="_handleLineChange(row.line)"
                                (updateSelectionHighlight)="updateSelectionRects()" (selectLeft)="moveSelectionLeft()"
                                (selectRight)="moveSelectionRight()" (selectAbove)="moveSelectionUp()"
                                (selectBelow)="moveSelectionDown()" [percentages]="this._percentages$ | async">
                            </line-row>

                            <line-row *ngSwitchCase="'text'" textLineElement [lineValue]="row"
                                [columns]="_columns['text']" [selection]="_selection$ | async" [index]="row.index"
                                [allowedUnits]="allowedUnits" (selectionChange)="updateSelectionRects()"
                                (change)="_handleLineChange(row.line)"
                                (updateSelectionHighlight)="updateSelectionRects()" (selectLeft)="moveSelectionLeft()"
                                (selectRight)="moveSelectionRight()" (selectAbove)="moveSelectionUp()"
                                (selectBelow)="moveSelectionDown()" [percentages]="this._percentages$ | async">
                            </line-row>

                            <line-row *ngSwitchCase="'tailAmount'" [lineValue]="row" [columns]="_columns['tailAmount']"
                                [selection]="_selection$ | async" [index]="row.index"
                                (selectionChange)="updateSelectionRects()" (change)="_handleLineChange(row.line)"
                                (updateSelectionHighlight)="updateSelectionRects()" (selectLeft)="moveSelectionLeft()"
                                (selectRight)="moveSelectionRight()" (selectAbove)="moveSelectionUp()"
                                (selectBelow)="moveSelectionDown()"
                                [percentages]="this._percentages$ | async"></line-row>

                            <line-row *ngSwitchCase="'tailPercentage'" [lineValue]="row"
                                [columns]="_columns['tailPercentage']" [selection]="_selection$ | async"
                                [index]="row.index" (selectionChange)="updateSelectionRects()"
                                (change)="_handleLineChange(row.line)"
                                (updateSelectionHighlight)="updateSelectionRects()" (selectLeft)="moveSelectionLeft()"
                                (selectRight)="moveSelectionRight()" (selectAbove)="moveSelectionUp()"
                                (selectBelow)="moveSelectionDown()"
                                [percentages]="this._percentages$ | async"></line-row>

                            <line-row *ngSwitchCase="'tailText'" textLineElement [lineValue]="row"
                                [columns]="_columns['tailText']" [index]="row.index" [selection]="_selection$ | async"
                                [index]="row.index" (selectionChange)="updateSelectionRects()"
                                (change)="_handleLineChange(row.line)"
                                (updateSelectionHighlight)="updateSelectionRects()" (selectLeft)="moveSelectionLeft()"
                                (selectRight)="moveSelectionRight()" (selectAbove)="moveSelectionUp()"
                                (selectBelow)="moveSelectionDown()"
                                [percentages]="this._percentages$ | async"></line-row>

                            <div class="subtotal-line" *ngSwitchCase="'tailSubtotal'">
                                <div class="cell spacer"
                                    [style.width]="_columns['tailSubtotal']['spacer'].width | percent:'1.0-6'"></div>
                                <div class="cell type"
                                    [style.width]="_columns['tailSubtotal']['type'].width | percent:'1.0-6'"></div>

                                <!-- Description -->
                                <div #description class="cell description"
                                    [style.width]="_columns['tailSubtotal']['description'].width | percent:'1.0-6'">
                                    <div>
                                        Tussentotaal
                                    </div>
                                </div>

                                <!-- Inter total  -->
                                <div class="cell amount"
                                    [style.width]="_columns['tailSubtotal']['amount']?.width ?? 0 | percent:'1.0-6'">
                                </div>

                                <!-- Sub total -->
                                <div #cell class="cell total" [value]="_subTotal"
                                    [style.width]="_columns['tailSubtotal']['total'].width | percent:'1.0-6'">
                                    {{row?.aggregation?.all.gross ?? 0 |
                                    currency:'EUR':'':null:'nl'}}
                                </div>
                            </div>

                            <div class="total-line" *ngSwitchCase="'total'">
                                <div class="description">{{row.description}}</div>
                                
                                <!-- Net total -->
                                <div class="amount"
                                    [style.width]="_columns['calculation']['total-net'].width | percent:'1.0-6'">
                                    {{row?.aggregation?.all.net ?? 0 |
                                    currency:'EUR':'':null:'nl'}}</div>

                                <!-- Gross total -->
                                <div class="amount"
                                    [style.width]="_columns['calculation']['total-gross'].width | percent:'1.0-6'">
                                    {{row?.aggregation?.all.gross ?? 0 |
                                    currency:'EUR':'':null:'nl'}}</div>
                            </div>

                            <!-- The row is a net provisional cost line after the tail -->
                            <div class="read-only" *ngSwitchCase="'readOnly'">
                                <div class="description">{{row.description}}</div>

                                <!-- Net total -->
                                <div class="amount"
                                    [style.width]="_columns['calculation']['total-net'].width | percent:'1.0-6'">
                                    <ng-container *ngIf="!!row?.aggregation?.all.net">
                                        {{row?.aggregation?.all.net ?? 0 |
                                        currency:'EUR':'':null:'nl'}}</ng-container>
                                    </div>

                                <!-- Gross total -->
                                <div class="amount"
                                    [style.width]="_columns['calculation']['total-gross'].width | percent:'1.0-6'">
                                    {{row?.aggregation?.all.gross ?? 0 |
                                    currency:'EUR':'':null:'nl'}}</div>
                            </div>

                        </ng-container>

                    </ng-container>
                </div>

            </div>
        </div>
        <div #scrollbarContainer class="virtual-scrollbar">
            <canvas #scrollbarBackground class="scrollbar-background"></canvas>
            <div #scrollHandle class="scroll-handle" [class.hidden]="hideScrollHandle$ | async"></div>
        </div>
    </div>
</div>